// extracted by mini-css-extract-plugin
export default {"container":"pitchDescription_container__oWe2t","description":"pitchDescription_description__hKL79","bannerImage":"pitchDescription_bannerImage__h53+c"};